<template>
  <Ineligible />
</template>

<script>
import Ineligible from '@/components/templates/Ineligible.vue'

export default {
  components: {
    Ineligible
  }
}
</script>
